// extracted by mini-css-extract-plugin
export default {"InputTextArea":"styles_InputTextArea__TjBxi"};